import CollaborationLayout from 'Layouts/collaboration/CollaborationLayout'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { DropdownItem, DropdownMenu, DropdownToggle, Input, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledDropdown, UncontrolledTooltip } from 'reactstrap'
import { FlagImage } from 'react-international-phone'
import { useCountries } from 'hooks/useCountries'
import userDummayImage from "../../assets/images/users/user-dummy-img.jpg";
import SimpleBar from 'simplebar-react';
import { AppDispatch, RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { Gig, Milestone, MilestoneEvent, MilestoneStep } from 'types/collaboration';
import { fetchCollaborationChatRoom, fetchCollaborationMilestoneData } from 'slices/collaborations/thunk';
import { fetchPermalinkFile } from 'slices/collaborations/files/reducer';
import GigSelectionModal from 'Components/collaboration/milestone/GigSelection';
import FormBuilderModal from 'Components/collaboration/milestone/FormBuilder';
import Timeline from 'Components/collaboration/milestone/tabs/Timeline';
import Specifications from 'Components/collaboration/milestone/tabs/Specifications';
import CollaborationContent from 'Components/collaboration/milestone/tabs/CollaborationContent';
import FeedbackModal from 'Components/collaboration/milestone/components/Feedback';
import DeadlineCalendarModal from 'Components/collaboration/milestone/components/DeadlineCalendar';
import { getErrorMessage, getMediaTypeFromURL, getSocialAccountProfileURL } from 'utils/helpers';
import "./collaboration.scss";
import InfluencerPostModal from 'Components/influencer/InfluencerPostModal';
import { useIdleTimer } from 'react-idle-timer';
import Loader from 'Components/Common/Loader';
import { fetchLegacyCollaborationThunk } from 'slices/legacy-collaborations/thunk';
import AddressSelectionModal from 'Components/collaboration/milestone/AddressSelection';
import { ADMIN_APP_URL } from 'constants/global';
import { toast } from 'react-toastify';
import SocialPostSelectionModal from 'Components/collaboration/milestone/SocialPostSelection';
import AccessControl from 'wrappers/AccessControl';
import { PRIVILEGE } from 'constants/privilege';
import { usePrivileges } from 'hooks/useAuth';
import Swal from 'sweetalert2';
import { forceCompleteMilestone, refreshSteps, resetCollab, resetMilestone, updateCTA } from 'services/api/collaboration';
import GigAdditionModal from 'Components/collaboration/milestone/GigAddition';
import { toggleSocialAccountView } from 'slices/ui/reducer';
import RequestCollabDeletionModal from 'Components/collaboration/RequestCollabDeletionModal';
import ReviewCollabDeletionModal from 'Components/collaboration/ReviewCollabDeletionModal';
const TaskMilestone = () => {

    const { campaignId, collaborationId, milestoneId } = useParams();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const filtersQuery = searchParams.get('filters');

    const tabsRef = useRef<HTMLDivElement | null>(null);
    const privileges = usePrivileges();

    // Redux Data //
    const influencerPostModalVisibile = useSelector((state: RootState) => state.ui.influencerPostModal);
    const milestoneData = useSelector((state: RootState) => state.collaborations.milestones?.[campaignId!]?.[collaborationId!]?.[milestoneId!]?.milestone);
    const activeMilestone = milestoneData?.milestone ?? null;
    const gigs = milestoneData?.gigs ?? [];

    const collaborationData = useSelector((state: RootState) => state.collaborations.items?.[campaignId!]?.[collaborationId!]);


    const legacyCollabData = useSelector((state: RootState) => state.legacyCollaborations.items[campaignId!]?.[collaborationId!]);

    const collaboration = legacyCollabData?.collaboration ?? null;
    const currency = collaboration?.currency ?? null;
    const country = collaboration?.country ?? null;
    const { countries } = useCountries();
    const countryOption = countries.find(
        (item) => item.value === (country || '').toUpperCase()
    );
    const milestonesList = legacyCollabData?.milestones ?? [];
    const campaign = collaborationData?.campaign;
    // console.log(activeMilestone, campaign, 'ahdfaodsfk')
    const posts = milestoneId ? (milestoneData?.posts ?? []) : (collaboration?.posts ?? []);
    const acknowledged = activeMilestone?.acknowledged_at ?? false;
    const [currentTasks, setCurrentTasks] = useState<MilestoneStep[]>([]);
    const [events, setEvents] = useState<MilestoneEvent[]>([]);
    const deletionRequest = collaboration?.deletion_request ?? null;
    const canRequestCollabDeletion = !!collaboration && (!deletionRequest || deletionRequest?.status === 'rejected');

    // Redux Data //

    // Local States //
    const [openedStep, setOpenedStep] = useState<string | null>(null);
    const [selectedMedia, setSelectedMedia] = useState<any>(null);
    const [activeTab, setActiveTab] = useState('timeline');
    const [isDownloading, setIsDownloading] = useState(false);
    const [showDisabledTooltip, setShowDisabledTooltip] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [deadlineCalendarStep, setDeadlineCalendarStep] = useState<MilestoneStep | null>(null);
    const [loading, setLoading] = useState(false);
    const [updateCTAURLModalOpen, setUpdateCTAURLModalOpen] = useState(false);
    const [ctaUpdating, setCTAUpdating] = useState(false);
    const [ctaURL, setCTAURL] = useState('');
    const [deletionRequestModalOpen, setDeletionRequestModalOpen] = useState(false);
    const [reviewDeletionModalOpen, setReviewDeletionModalOpen] = useState(false);
    // Local States //

    // Functions //    

    const getMilestoneName = (milestone: Milestone) => {
        return `${milestonesList.length > 1 ? `#${milestone?.sort_order} ` : ''}${milestone?.gig_type?.name}`
    }

    const fetchCollaborationMilestones = useCallback(async (force = false) => {
        if (campaignId && milestoneId && collaborationId)
            await dispatch(fetchCollaborationMilestoneData({ campaignId, milestoneId, collaborationId, force }))
    }, [dispatch, campaignId, milestoneId, collaborationId])

    const fetchCollaborationData = useCallback(async (force = false) => {
        if (campaignId && collaborationId)
            await dispatch(fetchLegacyCollaborationThunk({ campaignId, collaborationId, force }))
    }, [dispatch, campaignId, collaborationId])

    const onPlayButtonClick = async (gig: Gig) => {

        if (!campaignId || !collaborationId) return;
        try {
            const result = await dispatch(
                fetchPermalinkFile({ campaignId, collaborationId, permalink: gig.properties.permalink })
            ).unwrap();

            setSelectedMedia({ ...result.file, gig });
        } catch (error) {
            window.open(gig.properties.permalink, '_blank');
            console.log(error);
        }
    }

    const handleDownload = async (gig: Gig) => {
        if (!campaignId) return;

        try {
            // setIsDownloading(true);
            // const blob = await fetchCollaborationPermalinkFile(
            //     campaignId,
            //     gig.properties.permalink,
            //     'download'
            // );

            // const blobUrl = window.URL.createObjectURL(blob);
            // const link = document.createElement('a');
            // link.href = blobUrl;
            // link.setAttribute('download', `${gig.name}.mp4`);
            // document.body.appendChild(link);
            // link.click();
            // link.remove();
            // window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
        } finally {
            setIsDownloading(false);
        }
    };
    // Functions //

    // Memoized Data //
    const tabs = useMemo(() => {
        return [
            // { key: 'current', label: 'Current Task' },
            { key: 'timeline', label: 'Timeline' },
            ...(milestoneId ? [{ key: 'specs', label: 'Specs' }] : []),
            { key: 'content', label: 'Content' }
        ]
    }, [acknowledged, milestoneId])

    const getCurrentStepsComponents = useMemo(() => {
        let components: React.ReactNode[] = [];
        if (!activeMilestone) return components;

        const onCloseHandler = (refetch?: boolean) => {
            setOpenedStep(null)
            if (refetch) {
                fetchCollaborationMilestones(true);
            }
        }

        for (let task of currentTasks) {
            if (task.gig_step.slug === 'gig_selection') {
                components.push(
                    <GigSelectionModal
                        isActive={openedStep === 'gig_selection'}
                        onClose={onCloseHandler}
                        activeMilestone={activeMilestone}
                        gigs={gigs}
                        onPlayButtonClick={onPlayButtonClick}
                        handleDownload={handleDownload}
                        step={task}
                        currency={currency}
                    />
                )
            } else if (task.gig_step.slug === 'gig_addition') {
                components.push(
                    <GigAdditionModal
                        isActive={openedStep === 'gig_addition'}
                        onClose={onCloseHandler}
                        activeMilestone={activeMilestone}
                        gigs={gigs}
                        onPlayButtonClick={onPlayButtonClick}
                        handleDownload={handleDownload}
                        step={task}
                        currency={currency}
                    />
                )
            } else if (task.gig_step.slug === 'address_submission') {
                components.push(
                    <AddressSelectionModal
                        isActive={openedStep === 'address_submission'}
                        onClose={onCloseHandler}
                        activeMilestone={activeMilestone}
                        step={task}
                    />
                )
            } else if (['post_selection', 'reel_selection', 'story_selection', 'video_selection'].includes(task.gig_step.slug)) {
                components.push(
                    <SocialPostSelectionModal
                        isActive={openedStep === task.gig_step.slug}
                        onClose={onCloseHandler}
                        activeMilestone={activeMilestone}
                        gigs={gigs}
                        setSelectedMedia={(post: any) => setSelectedMedia(post)}
                        step={task}
                    />
                )
            } else {
                components.push(
                    <FormBuilderModal
                        isActive={openedStep === task.gig_step.slug}
                        onClose={onCloseHandler}
                        title={task.gig_step.title ?? task.gig_step.name}
                        activeMilestone={activeMilestone}
                        step={task}
                    />
                )
            }
        }
        return components;
    }, [currentTasks, activeMilestone, gigs, openedStep])

    // Memoized Data //


    // Lifecycle Methods //

    useEffect(() => {
        if (!milestoneId) {
            setActiveTab('timeline');
        }
    }, [milestoneId])


    useEffect(() => {
        if (!milestoneId && campaignId && collaborationId && Array.isArray(milestonesList) && milestonesList.length > 0) {
            const _milestones = [...milestonesList].sort((a, b) => b.sort_order - a.sort_order);
            navigate(`/tasks/${campaignId}/collaboration/${collaborationId}/milestone/${_milestones[0].id}`);
        }
    }, [milestoneId, milestonesList, campaignId, collaborationId])

    useEffect(() => {
        if (!milestoneData && !milestoneId && collaboration) {
            const pendingPost = (collaboration?.posts ?? []).find((post) => post.status === 'pending');

            const allRejected = (collaboration?.posts ?? []).filter((post) => post.status === 'rejected').length === (collaboration?.posts ?? []).length

            const step: MilestoneStep = {
                sort_order: 1,
                is_locked: false,
                is_processed: true,
                processed: null,
                deliverables: {
                },
                can_process: false,
                gig_step: {
                    slug: 'ig_media_approval',
                    name: "Instagram Media Approval*",
                    title: (pendingPost || allRejected) ? "Influencer has uploaded live media" : "Instagram media has been approved",
                    description: "",
                    cta_text: "",
                    revision_required_title: "",
                    processed_title: "",
                    object_name: "",
                    properties: [],
                    attributes: {},
                    require_deadline: false,
                },
                deadline: null,
                complete: !(pendingPost || allRejected)
            }
            setCurrentTasks([step]);
            setEvents([]);
            return;
        }
        if (Array.isArray(milestoneData?.active_steps)) {
            let steps = [...milestoneData?.active_steps].sort((a, b) => a.sort_order - b.sort_order);
            setCurrentTasks(steps);
        }
        if (Array.isArray(milestoneData?.events)) {
            let timelineEvents = [...milestoneData?.events].sort((a, b) => (new Date(a.created_at)).getTime() - (new Date(b.created_at)).getTime());
            setEvents(timelineEvents);
        }
    }, [milestoneData, milestoneId, collaboration])

    useEffect(() => {
        if (campaignId) {
            fetchCollaborationMilestones();
        }
    }, [campaignId, milestoneId, fetchCollaborationMilestones])

    useEffect(() => {
        if (campaignId && collaborationId) {
            fetchCollaborationData();
        }
    }, [campaignId, collaborationId, fetchCollaborationData])

    useEffect(() => {
        const hideDisabledTooltip = () => {
            setShowDisabledTooltip(false);
        }

        if (showDisabledTooltip) {
            setTimeout(() => {
                hideDisabledTooltip()
            }, 3000)
            document.addEventListener('scroll', hideDisabledTooltip);
        }

        return () => {
            document.removeEventListener('scroll', hideDisabledTooltip);
        }
    }, [showDisabledTooltip])

    useEffect(() => {
        if (milestoneData?.milestone?.cta_short_url) {
            setCTAURL(milestoneData.milestone.cta_short_url);
        }
    }, [milestoneData])

    // Lifecycle Methods //

    useIdleTimer({
        timeout: 1000 * 60 * 5, // 5 minutes
        onActive: () => {
            fetchCollaborationMilestones(true)
            fetchCollaborationData(true);
        },
        throttle: 1000,
    });

    const forceRefetch = async () => {
        setLoading(true);
        await fetchCollaborationMilestones(true);
        await fetchCollaborationData(true);
        setLoading(false);
    }


    useEffect(() => {
        setActiveTab('timeline');
    }, [collaborationId, campaignId, milestoneId])

    useEffect(() => {
        tabsRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [activeTab])

    const [creatingChatRoom, setCreatingChatRoom] = useState(false);

    const createChatRoom = async () => {
        if (creatingChatRoom || !campaignId || !collaborationId) return;
        setCreatingChatRoom(true);
        try {
            const { room } = await dispatch(fetchCollaborationChatRoom({ campaignId, collaborationId })).unwrap();
            if (room.uuid) {
                navigate(`/chat/${room.uuid}`);
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to open chat room, Please try again later!");
        } finally {
            setCreatingChatRoom(false);
        }
    }

    const onMilestoneReset = async () => {
        if (!privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.RESET)) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This action will reset this milestone. Do you want to continue?',
            confirmButtonColor: '#007AFF',
            confirmButtonText: 'Reset',
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#D33128',
            showCancelButton: true
        });

        if (result.isConfirmed && campaignId && collaborationId && milestoneId) {
            try {
                await resetMilestone(campaignId, collaborationId, milestoneId);
                await forceRefetch()
                toast.success("Milestone reset successfully!");
            } catch (error: any) {
                console.log(error);
                toast.error(getErrorMessage(error))
            }
        }

    }

    const onForceCompleteMilestone = async () => {
        if (!privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.FORCE)) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This action will forcefully complete this milestone. Do you want to continue?',
            confirmButtonColor: '#007AFF',
            confirmButtonText: 'Complete',
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#D33128',
            showCancelButton: true
        });

        if (result.isConfirmed && campaignId && collaborationId) {
            try {
                await forceCompleteMilestone(campaignId, collaborationId);
                await forceRefetch();
                toast.success("Milestone marked as completed!")
            } catch (error: any) {
                console.log(error);
                toast.error(getErrorMessage(error))
            }
        }

    }

    const onRefreshSteps = async () => {
        if (!privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.REFRESH)) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This action will refresh steps. Do you want to continue?',
            confirmButtonColor: '#007AFF',
            confirmButtonText: 'Refresh',
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#D33128',
            showCancelButton: true
        });

        if (result.isConfirmed && campaignId && collaborationId && milestoneId) {
            try {
                await refreshSteps(campaignId, collaborationId, milestoneId);
                await forceRefetch();
                toast.success("Steps refreshed successfully!");
            } catch (error: any) {
                console.log(error);
                toast.error(getErrorMessage(error))
            }
        }

    }

    const onCollabReset = async () => {
        if (!privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.RESET)) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This action will reset entire collaboration. Do you want to continue?',
            confirmButtonColor: '#007AFF',
            confirmButtonText: 'Reset',
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#D33128',
            showCancelButton: true
        });

        if (result.isConfirmed && campaignId && collaborationId) {
            try {
                await resetCollab(campaignId, collaborationId);
                await forceRefetch();
                toast.success("Collab reset successfully!");
            } catch (error: any) {
                console.log(error);
                toast.error(getErrorMessage(error))
            }
        }

    }

    const onCTAUpdate = async () => {
        if (!privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.PROCESS) || !campaignId || !collaborationId || !milestoneId || !ctaURL) return;

        try {
            setCTAUpdating(true);
            await updateCTA(campaignId, collaborationId, milestoneId, { url: ctaURL });
            await fetchCollaborationMilestones(true);
            setUpdateCTAURLModalOpen(false);
            toast.success('CTA URL updated successfully!');
        } catch (error) {
            console.log(error);
            toast.error(getErrorMessage(error))
        } finally {
            setCTAUpdating(false);
        }
    }

    if (loading) return <Loader />

    return (
        <CollaborationLayout>
            {
                !collaborationId &&
                <div className="d-flex h-100 w-100 justify-content-center align-items-center">
                    <div className="length-zero m-0">
                        <h3>No Task Selected!</h3>
                    </div>
                </div>
            }
            {
                collaborationId &&
                <div className="chat-content d-lg-flex">
                    <div className="w-100 overflow-hidden position-relative">
                        <div className="position-relative">
                            <div className="p-3 user-chat-topbar">
                                <div className="d-flex justify-content-between gap-2 align-items-center">
                                    <div className="d-flex align-items-center w-50">
                                        <div className="flex-shrink-0 d-block d-lg-none me-1">
                                            <Link to={{ pathname: "/tasks", search: filtersQuery ? `?filters=${filtersQuery}` : '' }} className="user-chat-remove fs-18 p-1"                              >
                                                <i className="ri-arrow-left-s-line align-bottom"></i>
                                            </Link>
                                        </div>
                                        <div className="flex-grow-1 overflow-hidden">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 chat-user-img online user-own-img align-self-center me-2 ms-0">
                                                    <button
                                                        type="button"
                                                        className="btn p-0 border-0 bg-transparent"
                                                        onClick={() => {
                                                            if (collaboration?.social_account?.uuid) {
                                                                dispatch(toggleSocialAccountView({
                                                                    socialAccountId: collaboration.social_account.uuid,
                                                                }));
                                                            }
                                                        }}
                                                    >
                                                        {collaboration?.social_account?.profile_picture_url ? (
                                                            <img src={collaboration.social_account?.profile_picture_url} className="rounded-circle avatar-xs" alt="" />
                                                        ) : (
                                                            <img src={userDummayImage} className="rounded-circle avatar-xs" alt="" />
                                                        )}
                                                    </button>
                                                </div>
                                                <div className="overflow-hidden">
                                                    <h5 className="text-truncate w-100 mb-0 fs-16">
                                                        <div className="d-flex align-items-center gap-1">

                                                            <a
                                                                className="text-reset username"
                                                                data-bs-toggle="offcanvas"
                                                                target='_blank'
                                                                rel='noreferrer noopener'
                                                                href={ADMIN_APP_URL + `/i/${collaboration?.influencer?.uuid}`}
                                                                aria-controls="userProfileCanvasExample"
                                                            >
                                                                {collaboration?.influencer?.name ?? collaboration?.social_account?.name ?? collaboration?.social_account?.handle}
                                                            </a>
                                                            {
                                                                collaboration?.hub &&
                                                                <a target='_blank' rel='noreferrer noopener' href={ADMIN_APP_URL + `/hub/${collaboration.hub?.uuid}`} className='text-reset'>[{collaboration.hub?.name}]</a>
                                                            }
                                                            {
                                                                collaboration?.social_account &&
                                                                <span onClick={() => dispatch(toggleSocialAccountView({ socialAccountId: collaboration?.social_account?.uuid!, influencerId: collaboration?.influencer?.uuid }))} className='text-reset cursor-pointer'>[@{collaboration?.social_account?.handle}]</span>
                                                            }
                                                        </div>

                                                        {/* {
                                                            collaboration?.social_account?.handle &&
                                                            <a href={getSocialAccountProfileURL(collaboration?.social_account?.handle, collaboration?.social_account?.platform)}>
                                                                <p className="fs-10 m-0">
                                                                    @{collaboration?.social_account?.handle}
                                                                </p>
                                                            </a>
                                                        } */}
                                                        <a
                                                            href={`/campaign/${collaboration?.campaign?.uuid}`}
                                                            target='_blank'
                                                            rel='noreferrer noopener'
                                                        >
                                                            <p className="text-muted fs-12 mb-0 d-flex align-items-center gap-1">
                                                                {
                                                                    country &&
                                                                    <>
                                                                        <span id="task-country-flag" className="d-inline-flex">
                                                                            <FlagImage
                                                                                iso2={countryOption?.iso2 || country.toLowerCase()}
                                                                                size="14px"
                                                                            />
                                                                        </span>
                                                                        <UncontrolledTooltip
                                                                            placement="top"
                                                                            target="task-country-flag"
                                                                            fade={false}
                                                                        >
                                                                            {countryOption?.label || country.toUpperCase()}
                                                                        </UncontrolledTooltip>
                                                                    </>
                                                                }
                                                                {collaboration?.campaign?.name}
                                                                {/* {
                                                                    collaboration?.language &&
                                                                    ` [${collaboration?.language?.name}]`
                                                                } */}
                                                            </p>

                                                        </a>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='w-100 d-flex justify-content-end align-items-center gap-2'>
                                        {
                                            activeMilestone &&
                                            <UncontrolledDropdown className='milestone-dropdown'>
                                                <DropdownToggle tag={"button"} className='milestone-dropdown-btn btn btn-white d-flex justify-content-between align-items-center w-100'>
                                                    <span className='text-truncate milestone-name-dropdown-text'>
                                                        {getMilestoneName(activeMilestone)}
                                                    </span>
                                                    <i className='mdi mdi-chevron-down text-007AFF fs-5' />
                                                </DropdownToggle>
                                                <DropdownMenu className='mt-1 p-0 w-100'>
                                                    {
                                                        milestonesList.map((_milestone, i) => <DropdownItem onClick={() => navigate(`/tasks/${campaignId}/collaboration/${collaborationId}/milestone/${_milestone.id}${filtersQuery ? '?filters=' + filtersQuery : ''}`)} key={i}>{getMilestoneName(_milestone)}</DropdownItem>)
                                                    }
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        }
                                        <span onClick={() => forceRefetch()} title='Refresh' className='cursor-pointer d-flex align-items-center'><i className='fs-4 bx bx-refresh text-primary' ></i></span>
                                        <UncontrolledDropdown className='milestone-dropdown'>
                                            <DropdownToggle tag={'span'} className='btn-white cursor-pointer border-0 d-flex justify-content-between align-items-center w-100'>
                                                <i className='mdi mdi-dots-vertical fs-5' />
                                            </DropdownToggle>
                                            <DropdownMenu className='mt-1 p-0 w-fit-content'>
                                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.RESET}>
                                                    <DropdownItem onClick={onMilestoneReset}>Reset Milestone</DropdownItem>
                                                </AccessControl>
                                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.FORCE}>
                                                    <DropdownItem onClick={onForceCompleteMilestone}>Force Complete Milestone</DropdownItem>
                                                </AccessControl>
                                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.REFRESH}>
                                                    <DropdownItem onClick={onRefreshSteps}>Refresh Steps</DropdownItem>
                                                </AccessControl>
                                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.COLLABORATION.PROCESS}>
                                                    <DropdownItem onClick={() => setUpdateCTAURLModalOpen(true)}>Update CTA URL</DropdownItem>
                                                </AccessControl>
                                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.COLLABORATION_MILESTONE.RESET}>
                                                    <DropdownItem onClick={onCollabReset}>Reset Collab</DropdownItem>
                                                </AccessControl>
                                                {
                                                    canRequestCollabDeletion &&
                                                    <DropdownItem onClick={() => setDeletionRequestModalOpen(true)}>Request Collab Deletion</DropdownItem>
                                                }
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </div>
                            </div>

                            <div className="position-relative" id="users-chat">
                                <div className="chat-conversation simplebar-scrollable-y" id="chat-conversation">
                                    <SimpleBar style={{ height: "100%" }}>
                                        <div className={`tab-controls milestone-tab-controls`} ref={tabsRef}>
                                            {tabs.map(tab => (
                                                <a
                                                    key={tab.key}
                                                    onClick={() => {
                                                        setActiveTab(tab.key)
                                                    }}
                                                    className={`milestone-tab d-flex align-items-center cursor-pointer justify-content-center gap-2 ${activeTab === tab.key ? 'active-tab' : ''}`}
                                                >
                                                    {tab.label}
                                                </a>
                                            ))}
                                        </div>
                                        {(deletionRequest) && (
                                            <div className={`collab-deletion-request-banner collab-deletion-request-banner--${(deletionRequest?.status || 'pending').toLowerCase()}`}>
                                                <div className="d-flex align-items-center justify-content-between gap-2">
                                                    <span className="collab-deletion-request-title">This collab removal request is {(deletionRequest?.status ?? 'pending').replace(/_/g, ' ')}.</span>
                                                    <AccessControl privilege={PRIVILEGE.CAMPAIGN.COLLABORATION.DESTROY} ifCondition={deletionRequest?.status === 'pending'}>
                                                        <span
                                                            className='text-primary cursor-pointer fw-bold'
                                                            onClick={() => setReviewDeletionModalOpen(true)}
                                                        >
                                                            <i className='mdi mdi-eye'></i> View & Take Action
                                                        </span>
                                                    </AccessControl>
                                                </div>
                                                {(deletionRequest?.remark) && (
                                                    <p className="collab-deletion-request-remark">{deletionRequest?.remark}</p>
                                                )}
                                            </div>
                                        )}
                                        <div className="milestone-tab-content">
                                            {/* <div className={`collapse ${activeTab === 'current' && 'show'}`}>
                                                <div className="d-flex flex-column gap-3">
                                                    {
                                                        currentTasks.map((currentTask, i) => {
                                                            return (
                                                                <CurrentStep
                                                                    onFeedbackView={(fb) => setFeedback(fb)}
                                                                    feedbacks={activeMilestone?.feedbacks ?? []}
                                                                    currentStep={currentTask}
                                                                    setOpenedStep={setOpenedStep}
                                                                    addDeadline={() => setDeadlineCalendarStep(currentTask)}
                                                                    key={i}
                                                                    setSelectedMedia={setSelectedMedia}
                                                                    onProcess={() => fetchCollaborationMilestones(true)}
                                                                />
                                                            )
                                                        })
                                                    }
                                                    {
                                                        !currentTasks.length &&
                                                        <div className='no-action'>
                                                            <h6>No Action Required</h6>
                                                            <span>There is no active task for this milestone!</span>
                                                        </div>
                                                    }
                                                </div>
                                            </div> */}
                                            <div className={`collapse ${activeTab === 'timeline' && 'show'}`}>
                                                {
                                                    // activeMilestone &&
                                                    <Timeline
                                                        onFeedbackView={(fb) => setFeedback(fb)}
                                                        active_steps={currentTasks}
                                                        events={events}
                                                        setOpenedStep={setOpenedStep}
                                                        milestone={activeMilestone}
                                                        addDeadline={(step) => setDeadlineCalendarStep(step)}
                                                        onPlayBtnClick={onPlayButtonClick}
                                                        setSelectedMedia={setSelectedMedia}
                                                        onStepProcess={() => fetchCollaborationMilestones(true)}
                                                    />
                                                }

                                            </div>
                                            <div className={`collapse ${activeTab === 'specs' && 'show'}`}>
                                                {
                                                    activeMilestone && campaign &&
                                                    <Specifications
                                                        campaign={campaign}
                                                        activeMilestone={activeMilestone}
                                                        acknowledgementRequired={false}
                                                        onAcknowledgement={() => fetchCollaborationMilestones(true)}
                                                        showDisabledTooltip={showDisabledTooltip}
                                                        setSelectedMedia={setSelectedMedia}
                                                    />
                                                }
                                            </div>
                                            <div className={`collapse ${activeTab === 'content' && 'show'}`}>
                                                <CollaborationContent collaborationPosts={posts} />
                                            </div>
                                        </div>
                                        {
                                            getCurrentStepsComponents.map((component) => component)
                                        }
                                        <FeedbackModal
                                            isActive={!!feedback}
                                            onClose={() => setFeedback('')}
                                            feedback={feedback}
                                        />
                                        <DeadlineCalendarModal
                                            isActive={!!deadlineCalendarStep}
                                            onClose={(refetch) => {
                                                setDeadlineCalendarStep(null)
                                                if (refetch) {
                                                    fetchCollaborationMilestones(true);
                                                }
                                            }}
                                            step={deadlineCalendarStep!}
                                        />
                                        <InfluencerPostModal
                                            isOpen={!!influencerPostModalVisibile}
                                            onClose={(processed) => {
                                                if (processed) {
                                                    fetchCollaborationMilestones(true);
                                                    fetchCollaborationData(true);
                                                }
                                            }}
                                            postId={influencerPostModalVisibile?.postId!}
                                            collaborationId={influencerPostModalVisibile?.collaborationId}
                                            influencer={influencerPostModalVisibile?.influencer}
                                            socialAccount={influencerPostModalVisibile?.socialAccount!}
                                            status={influencerPostModalVisibile?.status}
                                            milestoneStep={influencerPostModalVisibile?.milestoneStep}
                                        />
                                        <Modal centered isOpen={!!selectedMedia} toggle={() => setSelectedMedia(null)}>
                                            {/* <CloseButton top='0' onClose={() => setSelectedMedia(null)} /> */}
                                            <ModalBody className='p-0 overflow-hidden' style={{ borderRadius: '6px', height: '75vh' }}>
                                                {
                                                    selectedMedia &&
                                                    <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                                                        {
                                                            getMediaTypeFromURL(selectedMedia.url) === 'video' &&
                                                            <video src={selectedMedia.url} autoPlay controls className='h-100 w-100 bgc-content' />
                                                        }
                                                        {
                                                            getMediaTypeFromURL(selectedMedia.url) === 'image' &&
                                                            <div className="h-100 w-100 bg-media bgc-content" style={{
                                                                backgroundImage: `url(${selectedMedia.url})`
                                                            }}></div>
                                                        }
                                                        <div className="media-action">
                                                            {
                                                                selectedMedia.gig &&
                                                                <span className='cursor-pointer text-white fs-5' onClick={() => handleDownload(selectedMedia.gig)}><i className="fa-solid fa-download"></i></span>
                                                            }
                                                            <span className='text-white fs-5' onClick={() => setSelectedMedia(null)}><i className="fa-solid fa-circle-xmark"></i></span>
                                                        </div>
                                                    </div>
                                                }
                                            </ModalBody>
                                        </Modal>
                                        <Modal centered isOpen={updateCTAURLModalOpen} toggle={() => setUpdateCTAURLModalOpen(false)}>
                                            <ModalBody className='p-0 overflow-hidden'>
                                                <ModalHeader>
                                                    Update CTA URL
                                                </ModalHeader>
                                                <ModalBody>
                                                    <Input placeholder='Enter CTA URL' value={ctaURL} onChange={(e) => setCTAURL(e.target.value)} />
                                                </ModalBody>
                                                <ModalFooter className='border-top py-2'>
                                                    <button className='btn btn-outline-primary' onClick={() => setUpdateCTAURLModalOpen(false)}>Cancel</button>
                                                    <button className='btn btn-primary' disabled={ctaUpdating || !ctaURL} onClick={onCTAUpdate}>{ctaUpdating ? 'Updating...' : 'Update'}</button>
                                                </ModalFooter>
                                            </ModalBody>
                                        </Modal>

                                        <RequestCollabDeletionModal
                                            isActive={deletionRequestModalOpen}
                                            onClose={() => setDeletionRequestModalOpen(false)}
                                            onSuccess={() => fetchCollaborationData(true)}
                                        />
                                        {deletionRequest?.id && (
                                            <AccessControl privilege={PRIVILEGE.CAMPAIGN.COLLABORATION.DESTROY}>
                                                <ReviewCollabDeletionModal
                                                    isActive={reviewDeletionModalOpen}
                                                    requestId={deletionRequest.id}
                                                    onClose={() => setReviewDeletionModalOpen(false)}
                                                    onRejected={() => {
                                                        fetchCollaborationData(true)
                                                        fetchCollaborationMilestones(true)
                                                    }}
                                                />
                                            </AccessControl>
                                        )}
                                    </SimpleBar>
                                    <button onClick={createChatRoom} disabled={creatingChatRoom} className='btn btn-primary rounded-4 chat-help-btn'><i className='mdi mdi-chat-processing-outline'></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </CollaborationLayout>
    )
}

export default TaskMilestone